import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { generateSearchFormItem } from "../../../../../utils/helper";
import { SearchAccordion } from "../../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({ filter, data, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        enableReinitialize={true}
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          console.log(values);
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.Time",
                },
              ],
              defaultFilter(),
              t,
              data,
              "FLow Analysis",
              true
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
